globalConfigLoaded(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('cloneProjects', cloneProjects);

	cloneProjects.$inject = ['$rootScope', '$scope', '$timeout', '$compile', '$uibModal', 'siteService', 'projectAreaService', 'cloneProjectsService', 'storeService'];

	function cloneProjects($rootScope, $scope, $timeout, $compile, $uibModal, siteService, projectAreaService, cloneProjectsService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.source = undefined;
		vm.dest = undefined;
		vm.defaultAssignee = undefined;
		vm.projectIds = undefined;
		vm.approver = '';
		vm.factoryList = siteService.getUserSites();
		vm.showResults = false;
		vm.updateUsersList = updateUsersList;
		vm.clearErrorMessage = clearErrorMessage;
		vm.clone = clone;

		function clone() {
			vm.showResults = false;
			var args = {};
			args['projectIds'] = vm.projectIds;
			args['defaultAssignee'] = vm.defaultAssignee;
			args['approver'] = vm.approver;
			if (vm.source && vm.source.id && vm.dest && vm.dest.id && isValidSourceAndDestinationSite()){
				cloneProjectsService.cloneProjects(vm.source.id, vm.dest.id, args)
					.then(function(response) {
						if (response.status && response.status >= 400) {
							if (response.data && response.data.error) {
								$rootScope.$emit('toast', {'message': response.data.error, 'success': false});
							} else {
								$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
							}
						} else if (response.status && response.status == 201) {
							vm.approver = '';
							if (response.data.unsuccessful && response.data.unsuccessful.length > 0) {
								$rootScope.$emit('toast', {'message': 'Not all projects could be cloned', 'success': false});
							} else {
								$rootScope.$emit('toast', {'message': 'Projects cloned successfully', 'success': true});
							}
							vm.showResults = true;
							vm.totalProjects = response.data.total;
							vm.successfulProject = !response.data.successful ? 0 : response.data.successful.length;
							vm.unsuccessfulProjectsIds = !response.data.unsuccessful ? vm.projectIds :
								response.data.unsuccessful.toString();
							vm.unsuccessfulProjects = !response.data.unsuccessful ? response.data.total :
								response.data.unsuccessful.length;
							vm.details = response.data.details;
						}
					});
			}
		}

		function setInitialDefaults() {
			if (vm.factoryList && vm.factoryList.length) {
				vm.source = vm.factoryList[_.findIndex(vm.factoryList, function(factory) {return factory.id === adminConfig.factory.id;})];
				vm.dest = vm.factoryList[_.findIndex(vm.factoryList, function(factory) {return factory.id !== adminConfig.factory.id;})];
				if (vm.dest) {
					updateUsersList();
				}
			}
		}

		function loadUserList(factoryNdx) {
			projectAreaService.getUsers(factoryNdx).then(function (users) {
				vm.usersLists = users.data;
				vm.defaultAssignee = undefined;
			});
		}

		function updateUsersList() {
			loadUserList(vm.dest.id);
		}

		function addErrorMessage(errorContent) {
			vm.errorMessage = errorContent;
			$timeout(function() {
				vm.clearErrorMessage();
			}, 5000);
		}

		function clearErrorMessage() {
			vm.errorMessage = '';
		}

		function isValidSourceAndDestinationSite() {
			var sourceSite = globalConfig.user.authFacts[vm.source.id];
			var destinationSite = globalConfig.user.authFacts[vm.dest.id];
			if (vm.source.id === vm.dest.id) {
				addErrorMessage('Source and destination sites must be different.');
				return false;
			}
			if (sourceSite.isManualMonthlySavings !== destinationSite.isManualMonthlySavings) {
				addErrorMessage('Source and destination sites have different savings type.');
				return false;
			}
			return true;
		}

		setInitialDefaults();

	}
});
